import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { SupabaseAuthProvider } from './auth/EnhancedSupabaseAuthContext';
import { ProjectProvider } from './context/ProjectContext';
import { NotificationProvider } from './components/providers/NotificationProvider';
import { ToastProvider } from './styles/ToastContext';
import ErrorBoundary from './components/shared/ErrorBoundary';
import ChunkErrorBoundary from './components/routing/ChunkErrorBoundary';
import EnhancedAppRoutes from './routes/EnhancedAppRoutes';
import useAppDataInit from './hooks/useAppDataInit';
import { useRippleEffect } from './components/ui/PremiumTransitions';

function App() {
  // Initialiser le système de rafraîchissement automatique des données
  useAppDataInit({
    autoStart: true,
    refreshInterval: 30, // Rafraîchissement toutes les 30 minutes
    initialRefresh: true
  });

  // Activer les effets ripple sur tous les boutons
  useRippleEffect();

  return (
    <ErrorBoundary>
      <ChunkErrorBoundary>
        <SupabaseAuthProvider>
          <ProjectProvider>
            <NotificationProvider>
              <ToastProvider>
                <Router>
                  <div className="App">
                    <EnhancedAppRoutes />
                  </div>
                </Router>
              </ToastProvider>
            </NotificationProvider>
          </ProjectProvider>
        </SupabaseAuthProvider>
      </ChunkErrorBoundary>
    </ErrorBoundary>
  );
}

export default App;